import { Component, OnInit, Inject } from '@angular/core';
import { Payee } from '../../shared/sdk/models';
import { PayeeApi } from '../../shared/sdk/services';
import { Router } from '@angular/router';
import { DOCUMENT } from "@angular/platform-browser";
import { LoopBackConfig } from '../../shared/sdk/lb.config';
import { HttpClient,HttpHeaders } from  "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalEventsManager } from '../../events-manager.component'

@Component({
  selector: 'register',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.css']
})

export class RegisterComponent implements OnInit {

  user: Payee = new Payee();
  valid: boolean = true;
  confirmPassword: string = "";
  passwordValid: boolean = true;
  tcAgree: boolean = false;

  captcha;
  constructor(
    private userApi: PayeeApi,
    private router: Router,
    private eventsManager: GlobalEventsManager,
    private http:HttpClient,
    private sanitizer:DomSanitizer,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() { 
    window.scroll(0, 0);
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/script.js';
    script.onload = () => {
        console.log('SCRIPT LOAD active');
    };           
    script.onerror = () => console.log('SCRIPT ERROR'); 
    document.getElementsByTagName('head')[0].appendChild(script);

    this.getCaptcha();
  }

  getCaptcha(){
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +"/captchas/simpleEnqImg?time=" 
    this.http
      .get(_url+(new Date().getTime() / 1000), {responseType: 'text',withCredentials: true})
        .subscribe(
          data => {
            this.captcha = this.sanitizer.bypassSecurityTrustHtml(data.toString());
            // console.log({data})
          }, 
          error => {
            // console.log({error})
          }
        );
  }

  validate() {

    this.valid = true;
    let elements = this.document.getElementsByClassName('ng-invalid');
    console.log(elements);

    this.valid = this.checkPassword() && this.tcAgree;

    if (this.valid && elements.length == 0) {
      this.register();
    } else {
      this.valid = false;
      this.eventsManager.showPopUp('Please check you have filled in all fields correctly.');
    }

  }

  checkPassword() {
    this.passwordValid = this.user.password && this.confirmPassword && this.user.password == this.confirmPassword; 
    return this.passwordValid && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(this.user.password);
  }

  register() {
    LoopBackConfig.setRequestOptionsCredentials(true);
    this.userApi.create(this.user).subscribe(
      () => {
        this.router.navigate(['/welcome'])
        LoopBackConfig.setRequestOptionsCredentials(false);
      },
      err => {
        this.getCaptcha();
        LoopBackConfig.setRequestOptionsCredentials(false);
        console.log({err})
        if (err.code =="CAPTCHA_FAILED") {
          this.eventsManager.showPopUp(err.message);
        }
        else
          this.eventsManager.showPopUp(err.details.messages.email[0])
      }
    );
  }

}